/* eslint-disable @typescript-eslint/no-explicit-any */
export default function Badge(): any {
  return { MuiBadge: { styleOverrides: { dot: { width: 10, height: 10, borderRadius: "50%" } } } };
}
